module.exports = __webpack_public_path__ + "static/media/angular.97dd6ec6.png";